import { useAppSelector } from '../hooks'
import { CheckoutAppSelector } from '../store'
import { PPAModalState } from './reducer'

export const ppaModalSelector: CheckoutAppSelector<PPAModalState> = (state) => state.ppaModal

export const useGetPPAModalState = (): PPAModalState => useAppSelector(ppaModalSelector)
